import { DecimalPipe } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { AlertController, ModalController, Platform } from "ionic-angular";
import moment from "moment";
import { Observable } from "rxjs/Observable";
import { AssessmentDataService } from "../../../../providers/asmt-data-service/asmt-data-service";
import { IntercardDataService } from "../intercard-data/intercard-data.service";

const dateTimeFormat = "MM/DD/YYYY HH:mm";
const dateFormat = "MM/DD/YYYY";

/**
 * Generated class for the ListCardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "history-list-card",
  templateUrl: "history-list-card.html",
})
export class HistoryListCardComponent implements OnInit {
  @Input() assessmentId: string;
  @Input() sectionId: string;
  @Input() config;
  @Input() disabled: boolean = false;

  id: string;
  name: string;
  componentId: string;
  label: string;
  access: string;
  tooltip: object;
  dummyRow: object;
  declinable: boolean;
  editable: boolean = false;
  manualAdd: boolean = true;
  allowExternalData: boolean = false;

  colHeaders: string[];
  rawData: any[] = [];
  dataRows: any[] = [];
  dataPages: Array<object[]> = [];
  pageSize: number = 5;
  currentPage: number = 0;

  historyHeaders: string[];
  historyRows: any[] = [];
  historyPages: Array<object[]> = [];
  historyPageSize: number = 5;
  currentHistoryPage: number = 0;

  cardDepObs: Observable<any> = null;

  constructor(
    public modalCtrl: ModalController,
    public dataService: AssessmentDataService,
    public decimalPipe: DecimalPipe,
    public plt: Platform,
    private alertCtrl: AlertController,
    public translatePipe: TranslateService,
    public intercard: IntercardDataService
  ) {}

  get isNeedCard() {
    return this.id.toLocaleLowerCase() === "cl010.194";
  }

  protected getCellDisplayText(header, row) {
    // Checks if this is need card and the header being displayed is 'category'
    if (this.isNeedCard && header.toLowerCase() === "category") {
      // Checks if the value is 'other'
      if (row.values[header] && row.values[header].toString() === "other") {
        // Concatenates the name of the other need into the category name
        return [
          row.values[header].toString(),
          row.values["otherNeedName"],
        ].join(" - ");
      }
    }
    // If not,
    if (row.values && row.values[header]) {
      // We return the value if there is data
      return row.values[header].toString();
    }
    return "";
  }

  protected getTextTransformClass(header) {
    return this.isNeedCard && header.toLowerCase() === "category"
      ? "text-capitalized"
      : "";
  }

  ngOnInit(): void {
    this.id = this.config.id;
    this.name = this.config.cardName;
    this.componentId = this.config.componentId;
    this.label = this.config.cardName;
    this.access = this.config.access;
    this.tooltip = this.config.tooltip;
    this.colHeaders = this.config.data.listHeaders;
    this.historyHeaders = this.config.data.historyHeaders
      ? this.config.data.historyHeaders
      : this.colHeaders;
    this.declinable = this.config.declinable;
    if (this.config.editable) {
      this.editable = this.config.editable;
    }
    if (this.config.manualAdd !== undefined && this.config.manualAdd !== null) {
      this.manualAdd = this.config.manualAdd;
    }
    if (this.config.allowExternalData) {
      this.allowExternalData = this.config.allowExternalData;
    }

    this.dummyRow = { id: "" };
    let dummyData = {};
    for (let header of this.colHeaders) {
      dummyData[header] = "-";
    }
    this.dummyRow["values"] = dummyData;

    if (this.allowExternalData) {
      this.cardDepObs = this.intercard.register(this.name);
      this.cardDepObs.subscribe((data) => {
        // console.log( "Received emitted data from other card!", data );
        if (data == null || typeof data === "undefined") {
          return;
        }

        let newData = {};
        for (let header of this.colHeaders) {
          if (data[header]) {
            newData[header] = data[header];
          }
        }

        this.addData(newData);
      });
    }
  }

  @Input() set data(incomingData: any) {
    if (incomingData) {
      let cardData = incomingData;
      // Call some service to load rows and prevRow
      this.dataRows = [];
      if (cardData.data) {
        this.rawData = cardData.data;
        for (let data of cardData.data) {
          let info = { id: data.id };
          info["values"] = this.parseDataRow(data);
          this.dataRows.push(info);
        }
      }
      this.updateDataPages();

      // this.historyRows = [];
      if (cardData.history) {
        for (let item of cardData.history) {
          let info = { id: item.id };
          info["values"] = this.parseDataRow(item);
          this.historyRows.push(info);
        }
      }
      this.updateHistoryPages();

      // console.log("New ROWS:", this.dataRows);
      // console.log("New PREV:", this.prevRow);
    }
  }

  presentListForm(): void {
    let listModal = this.modalCtrl.create(
      "InputModalPage",
      {
        config: this.config,
      },
      { enableBackdropDismiss: false }
    );
    listModal.onDidDismiss((data) => {
      // console.log( "GOT DATA BACK!:" );
      // console.log(data);

      if (data !== undefined) {
        this.addData(data);
      }
    });
    listModal.present();
  }

  flattenIncomingData(data: object): object {
    let flatData = {};
    for (let key of Object.keys(data)) {
      if (typeof data[key] == "object") {
        let innerObj = data[key];
        if (innerObj == undefined) {
          continue;
        }

        if (
          key !== "reportedOn" &&
          key !== "date" &&
          key !== "dateOfFracture"
        ) {
          for (let innerKey of Object.keys(innerObj)) {
            let newKey =
              key + innerKey.replace(/\b\w/g, (l) => l.toUpperCase());
            flatData[newKey] = innerObj[innerKey];
          }
        } else if (key === "dateOfFracture") {
          let date = "00000000";
          if (innerObj["date"]) {
            date = innerObj["date"];
          }
          flatData[key] = date;
        } else {
          let date = "00000000";
          let time = "000000";
          if (innerObj["time"]) {
            time = innerObj["time"];
          }
          if (innerObj["date"]) {
            date = innerObj["date"];
          }
          flatData[key] = date + "T" + time;
        }
      } else {
        flatData[key] = data[key];
      }
    }
    // console.log( "FLATTENED IT: ", flatData );
    return flatData;
  }

  parseDataRow(data: object) {
    let values = {};
    let flatData = this.flattenIncomingData(data);
    if (flatData["resolvedBy"] && flatData["resolvedDate"]) {
      values["resolvedBy"] = flatData["resolvedBy"];
      values["resolvedDate"] = moment(flatData["resolvedDate"]).format(
        dateTimeFormat
      );
    }
    for (let header of this.colHeaders) {
      let val = "-";
      if (flatData[header]) {
        if (header === "date" || header === "reportedOn") {
          flatData[header] = moment(flatData[header]).format(dateTimeFormat);
        } else if (header === "dateOfFracture") {
          let dtFracture = flatData[header];
          if (dtFracture != "unknown") {
            flatData[header] = moment(flatData[header]).format(dateFormat);
          } else {
            flatData[header] = "Unknown";
          }
        }
        val = flatData[header];
      }
      values[header] = val;
    }
    // If this is a need card, we want to include additional data
    if (this.isNeedCard) {
      values["otherNeedName"] = flatData["otherNeedName"]
        ? flatData["otherNeedName"]
        : null;
    }
    return values;
  }

  addData(data: any): void {
    // console.log( "Data being pushed:" , data );
    if (data) {
      try {
        this.dataService
          .storeRecord(this.assessmentId, this.sectionId, this.id, data)
          .subscribe((returnData) => {
            //console.log( "Data returned from submission:", returnData );
            if (!returnData) {
              return;
            }

            let newData = { id: returnData.id };
            newData["values"] = this.parseDataRow(returnData);

            //console.log("Pushing new val.", newData);
            this.rawData.unshift(returnData);
            this.dataRows.unshift(newData);
            this.updateDataPages();
          });
      } catch (error) {
        //console.log( "Error during data submission and building.", error );
      }
    }
  }

  editRow(row: object): void {
    // console.log( "Editing row: ", row );

    let modalConfig = { config: this.config };

    let values = this.rawData.filter((record) => record.id == row["id"])[0];
    if (values !== null || values !== undefined) {
      let inputKeys = Object.keys(this.config.inputs);
      let editData = {};

      for (let key of inputKeys) {
        if (values[key]) {
          editData[key] = values[key];
        } else {
          editData[key] = null;
        }
      }
      modalConfig["data"] = editData;
    }

    // console.log( "Launching edit with modal config: ", modalConfig );
    let listModal = this.modalCtrl.create("InputModalPage", modalConfig, {
      enableBackdropDismiss: false,
    });
    listModal.onDidDismiss((data) => {
      // console.log( "GOT DATA BACK!:" );
      // console.log(data);

      if (data !== undefined) {
        this.editData(row, row["id"], data);
      }
    });
    listModal.present();
  }

  editData(oldRow: object, rowId: string, data: any): void {
    // console.log( "Data being pushed:" , data );
    if (data) {
      try {
        this.dataService
          .editRecord(this.assessmentId, this.sectionId, this.id, rowId, data)
          .subscribe((returnData) => {
            //console.log( "Data returned from edit:", returnData );

            let newData = { id: returnData.id };
            newData["values"] = this.parseDataRow(returnData);

            //console.log("Pushing new val.", newData);

            let rawData = this.rawData;
            for (let index in rawData) {
              if (rawData[index]["id"] === returnData.id) {
                rawData[index] = returnData;
                break;
              }
            }
            // console.log( "Updated rawData: ", this.rawData );

            this.dataRows.splice(this.dataRows.indexOf(oldRow), 1, newData);
            this.updateDataPages();
            ``;
          });
      } catch (error) {
        //console.log( "Error during data submission and building.", error );
      }
    }
  }

  deleteRow(id: string) {
    let alert = this.alertCtrl.create({
      title: this.translatePipe.instant("confirmDeleteRecord"),
      buttons: [
        {
          text: "Cancel",
        },
        {
          text: "Proceed",
          handler: () => {
            //console.log( "I'm going to delete: ", id );
            this.dataService
              .deleteRecord(this.assessmentId, this.sectionId, this.id, id)
              .subscribe(() => {
                //console.log( "Removing rows that match: ", id );
                this.rawData = this.rawData.filter((row) => row.id !== id);
                this.dataRows = this.dataRows.filter((row) => row.id !== id);
                this.updateDataPages();
              });
          },
        },
      ],
    });
    alert.present();
  }

  updateDataPages() {
    this.dataPages = [];

    let dataRows = this.dataRows;
    let pageSize = this.pageSize;
    let dataPages = this.dataPages;
    let pageIndex = -1;
    for (let i = 0; i < dataRows.length; i++) {
      let j = i % pageSize;
      if (j == 0) {
        dataPages.push([]);
        pageIndex++;
      }
      dataPages[pageIndex][j] = dataRows[i];
    }
    if (pageIndex > 0) {
      let endingRow = dataRows.length % pageSize;
      if (endingRow > 0) {
        for (let i = endingRow; i < pageSize; i++) {
          dataPages[pageIndex][i] = this.dummyRow;
        }
      }
    }

    if (this.currentPage > dataRows.length % pageSize) {
      this.prevPage();
    }
    // console.log( "Produced pages: ", this.dataPages );
  }

  firstPage() {
    if (this.currentPage !== 0) {
      this.currentPage = 0;
    }
  }

  prevPage() {
    if (this.currentPage > 0) {
      this.currentPage--;
    }
  }

  setPage(page) {
    if (
      page >= 0 &&
      page <= this.dataPages.length &&
      page !== this.currentPage
    ) {
      this.currentPage = page;
    }
  }

  nextPage() {
    if (this.currentPage < this.dataPages.length - 1) {
      this.currentPage++;
    }
  }

  lastPage() {
    if (this.currentPage !== this.dataPages.length - 1) {
      this.currentPage = this.dataPages.length - 1;
    }
  }

  updateHistoryPages() {
    this.historyPages = [];

    let dataRows = this.historyRows;
    let pageSize = this.historyPageSize;
    let dataPages = this.historyPages;
    let pageIndex = -1;
    for (let i = 0; i < dataRows.length; i++) {
      let j = i % pageSize;
      if (j == 0) {
        dataPages.push([]);
        pageIndex++;
      }
      dataPages[pageIndex][j] = dataRows[i];
    }
    if (pageIndex > 0) {
      let endingRow = dataRows.length % pageSize;
      if (endingRow > 0) {
        for (let i = endingRow; i < pageSize; i++) {
          dataPages[pageIndex][i] = this.dummyRow;
        }
      }
    }

    if (this.currentHistoryPage > dataRows.length % pageSize) {
      this.prevPage();
    }
    // console.log( "Produced pages: ", this.dataPages );
  }

  firstHistoryPage() {
    if (this.currentHistoryPage !== 0) {
      this.currentHistoryPage = 0;
    }
  }

  prevHistoryPage() {
    if (this.currentHistoryPage > 0) {
      this.currentHistoryPage--;
    }
  }

  setHistoryPage(page) {
    if (
      page >= 0 &&
      page <= this.historyPages.length &&
      page !== this.currentHistoryPage
    ) {
      this.currentHistoryPage = page;
    }
  }

  nextHistoryPage() {
    if (this.currentHistoryPage < this.historyPages.length - 1) {
      this.currentHistoryPage++;
    }
  }

  lastHistoryPage() {
    if (this.currentHistoryPage !== this.historyPages.length - 1) {
      this.currentHistoryPage = this.historyPages.length - 1;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/cards/history-list-card/history-list-card.ts